import searchArea from "./search/area.js";
import searchStation from "./search/station.js";
import searchSchool from "./search/school.js";
import SearchMap from "./search/map/index.js";
import estateIndex from "./estate/index.js";
import estateDetail from "./estate/detail.js";
import homeIndex from "./home/index.js";
import soldIndex from "./sold/index.js";
import soldDetail from "./sold/detail.js";
import errorIndex from "./error/index.js";

const pages = () => {
    homeIndex();
    searchArea();
    searchStation();
    searchSchool();
    SearchMap();
    estateIndex();
    estateDetail();
    soldIndex();
    soldDetail();
    errorIndex();
};
export default pages;
